module.exports = __webpack_public_path__ + "img/13.6e29f8e4.jpg";